import React from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';
import './adminUserDialogs.css';

export const AdminUserDialog = ({ account, title, icon: Icon, testid, titleTestid, accountTestid, busy, onClose, children, className = '' }) => <Dialog open onOpenChange={(open) => { if (!open && !busy) onClose(); }}>
  <DialogContent className={`admin-user-dialog ${className}`} data-testid={testid}>
    <header className="admin-dialog-heading">
      <DialogTitle data-testid={titleTestid}><Icon size={21} aria-hidden="true" />{title}</DialogTitle>
      <DialogDescription className="admin-dialog-account" data-testid={accountTestid}>
        <span data-testid={`${accountTestid}-username`}>{account.username}</span>
        {account.email && <span data-testid={`${accountTestid}-email`}>{account.email}</span>}
      </DialogDescription>
    </header>
    {children}
  </DialogContent>
</Dialog>;